module.exports = {
      id: "books-vikatan-usage",
      viewBox: "0 0 22 29.5",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#books-vikatan",
      toString: function () {
        return this.url;
      }
    }